module.exports = __webpack_public_path__ + "img/mineA.3ad2c4e3.png";